import { Star, Quotes } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../data/constants";

export default function Testimonials({ items = TESTIMONIALS }) {
  return (
    <section className="section-pad bg-[#F8FAFC]" data-testid="testimonials">
      <div className="container-wide">
        <div className="eyebrow">From our customers</div>
        <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl">
          Real GTA homeowners. Real emergencies. Real fixes.
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {items.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative rounded-sm bg-white border border-[#E2E8F0] p-6 md:p-8 flex flex-col"
            >
              <Quotes
                size={40}
                weight="fill"
                className="text-[#FF6B00] absolute -top-3 left-6"
              />
              <div className="flex items-center gap-1 text-[#FF6B00] mt-2">
                {Array.from({ length: t.rating || 5 }).map((_, k) => (
                  <Star key={k} size={18} weight="fill" />
                ))}
              </div>
              <p className="mt-4 text-[#1B2A4A] text-base md:text-lg leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 pt-4 border-t border-[#E2E8F0]">
                <div className="font-display font-bold text-[#1B2A4A]">{t.name}</div>
                <div className="text-sm text-[#4B5563]">{t.city}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
